module.exports = __webpack_public_path__ + "static/media/success.db9b0da9.svg";